import { useReferenceState } from "lib/@hooks/use-reference"
import { ContentLanguageChanged } from "./translation-event-definitions.mjs"

/**
 * Hook to get and set the current content language.
 * Uses useReferenceState which shares state reactively across all
 * components using the same key (via localStorage + events).
 * No Provider needed.
 *
 * @returns {{ language: string, languageName: string, rtl: boolean, setLanguage: (code: string, isRtl?: boolean, name?: string) => void }}
 */
export function useContentLanguage() {
    const [language, setLanguageState] = useReferenceState("content-language", "en")
    const [languageName, setLanguageNameState] = useReferenceState("content-language-name", "")
    const [rtl, setRtl] = useReferenceState("content-language-rtl", false)

    return { language, languageName, rtl, setLanguage }

    function setLanguage(code, isRtl, name) {
        setLanguageState(code)
        setRtl(isRtl ?? false)
        setLanguageNameState(name ?? "")
        ContentLanguageChanged.raiseOnce()
    }
}
